// extracted by mini-css-extract-plugin
module.exports = {"power-independence-M":"M_power-independence-M__CNOfq"};